module.exports = __webpack_public_path__ + "static/media/mobile_logo_2x.794dd5c7.png";